import type { SupplierAuditEntry, SupplierLog } from '../types'
import { readJson, STORAGE_KEYS, writeJson } from './storage'

export class SupplierLogRepository {
  list(supplierId?: string): SupplierLog[] {
    const all = readJson<SupplierLog[]>(STORAGE_KEYS.logs, 'logs', [])
    if (!supplierId) return all
    return all.filter((l) => l.supplierId === supplierId)
  }

  add(supplierId: string, event: string, message: string, status: string): SupplierLog {
    const entry: SupplierLog = {
      id: crypto.randomUUID(),
      supplierId,
      event,
      message,
      status,
      createdAt: new Date().toISOString(),
    }
    writeJson(STORAGE_KEYS.logs, 'logs', [entry, ...this.list()].slice(0, 500))
    return entry
  }
}

export class SupplierAuditRepository {
  list(supplierId?: string): SupplierAuditEntry[] {
    const all = readJson<SupplierAuditEntry[]>(STORAGE_KEYS.audit, 'audit', [])
    if (!supplierId) return all
    return all.filter((a) => a.supplierId === supplierId)
  }

  add(
    supplierId: string,
    field: string,
    previousValue: string,
    newValue: string,
    changedBy = 'admin@masterhub.com',
  ): SupplierAuditEntry {
    const entry: SupplierAuditEntry = {
      id: crypto.randomUUID(),
      supplierId,
      field,
      previousValue,
      newValue,
      changedBy,
      changedAt: new Date().toISOString(),
    }
    writeJson(STORAGE_KEYS.audit, 'audit', [entry, ...this.list()].slice(0, 500))
    return entry
  }
}

export const supplierLogRepository = new SupplierLogRepository()
export const supplierAuditRepository = new SupplierAuditRepository()
